import type { TemplateMeta } from '../../types';
import { CalendarIcon } from './components/Icon';

export const calendarMeta: TemplateMeta = {
  name: 'Calendar',
  orientation: 'landscape',
  Icon: CalendarIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Calendar',
  eventListDisplayFullLabel: null,
  eventListRangePicker: 'month-range',
  featureFlag: 'calendarPrintableEnabled',
};
